import { Box } from "@mui/material";
import { Error } from "utils";

export default function NoTenant(){
    return (
        <Box m={2}>
            <Error error="No Tenant provided" />
        </Box>
    )    
}